import { render, staticRenderFns } from "./AddDoTplDialog.vue?vue&type=template&id=24678d12&scoped=true"
import script from "./AddDoTplDialog.vue?vue&type=script&lang=js"
export * from "./AddDoTplDialog.vue?vue&type=script&lang=js"
import style0 from "./AddDoTplDialog.vue?vue&type=style&index=0&id=24678d12&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24678d12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24678d12')) {
      api.createRecord('24678d12', component.options)
    } else {
      api.reload('24678d12', component.options)
    }
    module.hot.accept("./AddDoTplDialog.vue?vue&type=template&id=24678d12&scoped=true", function () {
      api.rerender('24678d12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/components/AddDoTplDialog.vue"
export default component.exports